module.exports = __webpack_public_path__ + "static/media/01_A7_03.ae83a768.png";